import { Input } from "@components/ui/input";
import { Box, Modal } from "@mui/material";
import React, { useState } from "react";

import { Button } from "@/components/ui/button";
import { X } from "lucide-react";
import { addCampaignMessage } from "@redux/slices/campaign";
import LoadingScreen from "@components/LoadingScreen";
import SimpleBar from "simplebar-react";
import ReactQuill from "react-quill"; // Import React Quill
import "react-quill/dist/quill.snow.css"; // Import Quill styles

interface AddCampaignProps {
  closeModal: boolean;
  setCloseModal: (value: boolean) => void;
  showModal: boolean;
  handleCloseModal: () => void;
  id: number;
  sequenceId: number; // New prop for sequence ID
}

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 490,
  height: 560,
  borderRadius: "6px",
  backgroundColor: "#F4F4F4",
  color: "#3F3F46",
  p: 4,
};

const AddCampaign: React.FC<AddCampaignProps> = ({
  closeModal,
  handleCloseModal,
  showModal,
  id,
  sequenceId,
}) => {
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const [message, setMessage] = useState("");

  // Define custom toolbar options
  const toolbarOptions = [
    ['bold', 'italic'], // Ensure both Bold and Italic buttons are included
    ['link'], // Link button
    [{ 'list': 'ordered' }, { 'list': 'bullet' }], // Numbered and Bullet List buttons
    ['clean'] // Clear formatting button
  ];

  const handleChangeMessage = (newValue: string) => {
    setMessage(newValue); // Update message with the HTML content
  };

  const handleClose = () => {
    handleCloseModal();
  };

  const addCampaign = async () => {
    setLoading(true);
    const messageData = {
      subject: name,
      message: message,
      campaign_id: id,
      sequence_id: sequenceId
    };

    await addCampaignMessage(messageData);
    setLoading(false);

    handleCloseModal();
  };

  console.log("Selected Sequence ID:", sequenceId);

  return (
    <>
      {loading ? (
        <LoadingScreen />
      ) : (
        <div>
          <Modal
            open={showModal}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <div className="flex items-center justify-between">
                <h4 className="text-xl font-bold flex items-center">
                  Add Campaign Message
                </h4>
                <X onClick={handleClose} className="cursor-pointer" />
              </div>

              <Input
                placeholder="Enter subject"
                className="my-3 mt-5"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />

              <SimpleBar style={{ maxHeight: 330 }}>
                <ReactQuill 
                  value={message} 
                  onChange={handleChangeMessage} 
                  theme="snow" // You can choose different themes
                  modules={{
                    toolbar: toolbarOptions // Use the custom toolbar
                  }}
                />
              </SimpleBar>
              <div className="flex justify-end absolute bottom-[30px] right-[30px]">
                <Button onClick={addCampaign}>Add Message</Button>
              </div>
            </Box>
          </Modal>
        </div>
      )}
    </>
  );
};

export default AddCampaign;
